import React from 'react'

import BaseMakeDropdown from 'components/BaseMakeDropdown'

interface MarineMakeDropdownProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formik: any
    assetType?: string
    dataSource?: string[]
    assetSubType?: string
}

export default function MakeDropdown(props: Readonly<MarineMakeDropdownProps>) {
    return (
        <BaseMakeDropdown
            {...props}
            dropdownType="vehicle"
            fieldNamePrefix="marine"
        />
    )
}
